export const getCreatorHandleWithPrefix = (handle: string, prefix = '@') => {
  if (handle?.startsWith(prefix)) {
    return handle;
  }

  return `${prefix}${handle}`;
};
